import { aclPermissions, hasPermissions } from "const/ACLPermissions"
import React, { Component } from "react"
import 'asset/style/dashboard.css'
import 'asset/style/add_case.css'
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons"
import {isArrayEqual, isSuperuser} from "utils/utils"
import {Row, Col, Input, Button} from "antd"
import { connect } from "react-redux"
import {Divider} from "@mui/material";
import 'asset/style/theme/theme.scoped.scss';


class ManageGroup extends Component {

    constructor (props) {
        super(props)

        this.state = {
            selectedGroups: [],
            inputAvailable: '',
            inputSelected: '',
            validGroups: [],
        }

        this.availableGroupSelectId = "available-group-select-id"
        this.selectedGroupSelectId = "selected-group-select-id"
        this.is_superuser = isSuperuser()
    }

    componentDidMount(prevProps, prevState) {
        if (this.props?.allGroups !== {}) {
            this.setState({validGroups: this.getValidGroups()})
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let groups_valid = this.state.validGroups

        if (prevProps?.allGroups !== this.props?.allGroups || prevProps?.organisation !== this.props?.organisation) {
            const groups = this.getValidGroups();
            this.setState({validGroups: groups})
            groups_valid = groups
        }

        if (!(prevState.selectedGroups === this.state.selectedGroups ||
            isArrayEqual(prevState.selectedGroups, this.state.selectedGroups))) {
            const groups =
                this.state.selectedGroups
                    ?.map(g => groups_valid.find(e => e.name === g)?.id)
                    ?.filter(e => !isNaN(e))

            if (groups && !isArrayEqual(groups, this.props.groups)) {
                this.props.setGroups(groups)
            }
        }

        if (!(prevProps.groups === this.props.groups ||
            isArrayEqual(prevProps.groups, this.props.groups)) || !(prevState.validGroups === this.state.validGroups ||
            isArrayEqual(prevState.validGroups, this.state.validGroups))) {
            const selectedGroups =
                this.props.groups
                    ?.map(g => groups_valid.find(e => e.id === g)?.name)
                    ?.filter(e => !!e)

            if (selectedGroups && !isArrayEqual(selectedGroups, this.state.selectedGroups)) {
                this.setState({ selectedGroups })
            }
        }
    }

    getValidGroups = () => {
            const organisation_id = this.props.organisation
            return Object.values(this.props.allGroups || {})
                    ?.filter(({ organisation }) => organisation === organisation_id)
                || []
    }

    addGroup = () => {
        const options = document.getElementById(this.availableGroupSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected || this.state.selectedGroups.includes(option.value)) continue
            selected.push(option.value)
        }

        this.setState(state => {
            const selectedGroups = [...state.selectedGroups, ...selected]
            selectedGroups?.sort()

            return {
                ...state,
                selectedGroups,
            }
        })
    }

    removeGroup = () => {
        const options = document.getElementById(this.selectedGroupSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => {
            const selectedGroups = state.selectedGroups.filter(e => !selected.includes(e))
            return {
                ...state,
                selectedGroups,
            }
        })
    }

    renderAvailableGroups = (selectedGroups, hint) => {
        return (
            <select multiple className="multi_select_box group_select_box" id={this.availableGroupSelectId}>
                {this.state.validGroups?.filter(p => p.name.includes(hint))?.map(({name}) => name)?.map(g => {
                    const disabled = this.state.selectedGroups?.includes(g)
                    if (disabled){
                        return <option
                            key={`available_group_option_${g}`}
                            disabled
                            selected={false}>
                            {g}
                        </option>
                    }else {
                        return <option
                            key={`available_group_option_${g}`}
                            >
                            {g}
                        </option>
                    }
                })}
            </select>
        )
    }

    renderSelectedGroups = (selectedGroups, hint) => {
        return (
            <select multiple className="multi_select_box group_select_box" id={this.selectedGroupSelectId}>
                {selectedGroups?.filter(p => p.includes(hint))?.map(g => (
                    <option key={`selected_group_option_${g}`}>
                        {g}
                    </option>
                ))}
            </select>
        )
    }

    render() {
        return hasPermissions([aclPermissions.update_user]) ? (
                <Row span={24} style={{marginLeft: "40px"}}>
                    <Col span={24}>
                        <div style={{fontSize: 20, fontWeight: 400}}>User Groups</div>
                        <Divider color={"#000"} style={{opacity: "0.2", marginRight: 20, marginTop: 10}}/>
                    </Col>
                    <Col span={24}>
                        <div>
                            <Row className="add-case-row" type="flex" style={{borderBottom : "None"}}>
                                <Col span={9}>
                                    <Row span={5} className="add-case-row-header">
                                        <b>Available Groups</b>
                                    </Row>
                                    <Row span={5} className="add-case-row-header">
                                        <Input
                                            autoComplete="off"
                                            className="input-field-add-case"
                                            style={{color: 'black', width: '100%'}}
                                            value={this.state.inputAvailable}
                                            placeholder={'Search'}
                                            onChange={e => this.setState({inputAvailable: e?.target?.value})}
                                        />
                                    </Row>
                                    <Row span={5} className="add-case-row-header" push={3}>
                                        {this.renderAvailableGroups(this.state.selectedGroups, this.state.inputAvailable?.trim())}
                                    </Row>
                                </Col>
                                <Col
                                    offset={1}
                                    style={{
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "center",
                                        "flex-direction": "column",
                                        gap: "16px"
                                    }}
                                >
                                    <Row>
                                        <Button type="default" onClick={this.addGroup}>
                                            <ArrowRightOutlined/>
                                        </Button>
                                    </Row>
                                    <Row>
                                        <Button type="default" onClick={this.removeGroup}>
                                            <ArrowLeftOutlined/>
                                        </Button>
                                    </Row>
                                </Col>
                                <Col span={9} offset={1}>
                                    <Row span={5} className="add-case-row-header">
                                        <b>Selected Groups</b>
                                    </Row>
                                    <Row span={5} className="add-case-row-header">
                                        <Input
                                            autoComplete="off"
                                            className="input-field-add-case"
                                            style={{color: "black", width: "100%"}}
                                            value={this.state.inputSelected}
                                            placeholder={'Search'}
                                            onChange={e => this.setState({inputSelected: e?.target?.value})}
                                        />
                                    </Row>
                                    <Row span={5} className="add-case-row-header">
                                        {this.renderSelectedGroups(this.state.selectedGroups, this.state.inputSelected?.trim())}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            ) :
            <></>
    }
}


const mapStateToProps = (state) => {
    return {
        allGroups: state.searchUserReducer?.groups,
    }
}

export default connect(mapStateToProps)(ManageGroup)